import _ from "lodash";

import ms from "ms";
import type { NormalizedCustomerDto } from "helpers/normalizeCustomerDto";
import ApiClient from "services/ApiClient";
import ApiClientViewTracker from "services/ApiClientViewTracker";

import Storage from "core/Storage";

import HEADERS from "../constants/HEADERS";
import STORAGE from "../constants/STORAGE";

//
// ─── AUTH FUNCTIONS ─────────────────────────────────────────────────────────────
//
const AuthReset = () => {
  Storage.Local.remove(STORAGE.requestedPhoneNumber);
  Storage.Local.remove(STORAGE.authToken);
  Storage.Local.remove(STORAGE.authMemberDetails);
  ApiClient.removeHeader(HEADERS.authorization);
  ApiClient.removeHeader(HEADERS.memberId);
  ApiClient.removeHeader(HEADERS.memberRole);
  ApiClientViewTracker.removeHeader(HEADERS.authorization);
  ApiClientViewTracker.removeHeader(HEADERS.memberId);
  ApiClientViewTracker.removeHeader(HEADERS.memberRole);
};

const AuthTokenSave = (token: string): void => {
  Storage.Local.set(STORAGE.authToken, token, _.now() + ms("24 hours"));
  ApiClient.setHeader(HEADERS.authorization, `Bearer ${token}`);
  ApiClientViewTracker.setHeader(HEADERS.authorization, `Bearer ${token}`);
};

const AuthMemberSave = (memberDetails: NormalizedCustomerDto): void => {
  Storage.Local.set(
    STORAGE.authMemberDetails,
    memberDetails,
    _.now() + ms("24 hours")
  );
  ApiClient.setHeader(HEADERS.memberId, String(memberDetails.id));
  ApiClient.setHeader(HEADERS.memberRole, String(memberDetails.role));
  ApiClientViewTracker.setHeader(HEADERS.memberId, String(memberDetails.id));
  ApiClientViewTracker.setHeader(
    HEADERS.memberRole,
    String(memberDetails.role)
  );
  const customerBasicInfo = _.pick(memberDetails, [ "firstName", "phone" ]);
  Storage.Local.set(
    STORAGE.authMemberBasicDetails,
    customerBasicInfo,
    _.now() + ms("31 days")
  );
};

const AuthGet = () => {
  return {
    token: Storage.Local.get(STORAGE.authToken),
    memberDetails: Storage.Local.get(STORAGE.authMemberDetails)
  };
};

export { AuthReset, AuthGet, AuthTokenSave, AuthMemberSave };
